'use client';

import { useUpdateCheck } from '@/hooks/use-update-check';
import { useCallback } from 'react';

export function UpdateAvailableBanner() {
  const updateAvailable = useUpdateCheck(true);

  const handleRefresh = useCallback(() => {
    window.location.reload();
  }, []);

  if (!updateAvailable) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[100] flex items-center justify-center gap-3 bg-primary px-4 py-3 text-primary-foreground shadow-lg sm:bottom-auto sm:top-0"
      role="alert"
    >
      <span className="text-sm font-medium">
        Nova versão disponível. Recarregue a página para atualizar.
      </span>
      <button
        type="button"
        onClick={handleRefresh}
        className="shrink-0 rounded-lg bg-primary-foreground px-3 py-1.5 text-sm font-medium text-primary hover:opacity-90"
      >
        Recarregar
      </button>
    </div>
  );
}
